import './index.styl'
import useI18n from '@/i18n/landing'
import mapping from './mapping'
import controller from './controller'
import $ from 'zepto'
import { PORTAL_URL } from '@/types'

const Index = {
  stage: 'default',
  template(stage = 'default') {
    this.stage = stage
    const $i18n = useI18n()
    setTimeout(() => this.mounted(), 0)
    const button = mapping[stage].button
      ? `<button class="next-btn" id="js_btn">${mapping[stage].button}</button>`
      : ''

    return `<div class="maintenance">
    <div class="maintenance-alert">${
      mapping[stage].title
    }</div>
    <div class="maintenance-img">
      <img src="${mapping[stage].icon}" />
    </div>
    <div class="maintenance-to-download">${
      mapping[stage].content
    }
    </div>
   ${button}
    <div class="maintenance-know">
      <a href="${PORTAL_URL}"> ${$i18n.$t(
      'Fintech_Credit_process_bbcs_magE',
      {
        brand: $i18n.$t('financial.loan.freya.brand.name'),
      }
    )}</a>
    </div>
  </div>`
  },
  mounted() {
    mapping[this.stage].track()
    $('#js_btn').on('click', () => {
      mapping[this.stage].track(false)
      controller().openApp()
    })
  },
}
export default Index
